import { Component, Injector, Input, OnChanges, Output, SimpleChanges, Type, EventEmitter } from '@angular/core';
import { EXTENSION_CONTEXT, ExtensionContext, ON_SUBMIT_TOKEN} from './extension-context';
import { resolveExtension } from './extensions.registry';

interface ExtensionEntry {
  componente: Type<any>;
  injector: Injector;
}

@Component({
  selector: 'app-extension-slot',
  template: `
    <ng-container *ngFor="let ext of entradas">
      <ng-container *ngComponentOutlet="ext.componente; injector: ext.injector"></ng-container>
    </ng-container>
  `
})
export class ExtensionSlotComponent implements OnChanges {

  @Input() extensiones: string[] = [];
  @Input() context: ExtensionContext;
  @Output() retornoGrabar = new EventEmitter();

  entradas: ExtensionEntry[] = [];

  constructor(private parentInjector: Injector) {}

  ngOnChanges(_: SimpleChanges) {
    if (!this.context || !this.extensiones || this.extensiones.length === 0) {
      this.entradas = [];
      return;
    }

    this.entradas = this.extensiones
      .map(cod => {
        const componente = resolveExtension(cod);
        if (!componente) {
          console.warn(`[ExtensionSlot] Codigo no registrado: ${cod}`);
          return null;
        }
        const ctx: ExtensionContext = { ...this.context, SYS02EXT: cod };
        const injector = Injector.create({
          providers: [{ provide: EXTENSION_CONTEXT, useValue: ctx }, { provide: ON_SUBMIT_TOKEN, useValue: (data: any) => this.manejarEvento(data) }],
          parent: this.parentInjector
        });
        return { componente, injector };
      })
      .filter((e): e is ExtensionEntry => e !== null);
  }

  manejarEvento(data: any){
    this.retornoGrabar.emit("Recargar");
  }
}
